"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableFooter_1 = require("./TableFooter");
exports.default = TableFooter_1.default;
//# sourceMappingURL=index.js.map